@if (toast() && toast().open) {
  <gplus-snackbar
    class="gplus-snackbar"
    [ngClass]="toast().level"
    [type]="toast().level"
    [icon]="iconsMap[toast().level]"
    [text]="toast().message"
    [closeable]="toast().enableCloseButton"
    (closed)="close()"
  />
}
